export default {
    path: '/user_pay',
    meta: {
        title: '支付详情',
    },
    component: r => require.ensure([], () => r(require(`./user_pay.vue`)), `/user_pay`),
}


// WEBPACK FOOTER //
// ./src/views/Open/router.js